/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerDownRightIcon64Regular = forwardRef('ArrowDCornerDownRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M20.5 41a9.5 9.5 0 0 1-9.5-9.5v-24a1.5 1.5 0 0 1 3 0v24a6.5 6.5 0 0 0 6.5 6.5h31.11a2.516 2.516 0 0 0-.232-.268L36.439 22.794a1.5 1.5 0 0 1 2.122-2.122l14.938 14.939a5.5 5.5 0 0 1 0 7.778L38.561 58.328a1.5 1.5 0 1 1-2.122-2.122l14.939-14.938A2.52 2.52 0 0 0 51.61 41H20.5Z" })));
});
